import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

const LeadContactGroupFormDialog = ({ open, onClose, onSubmit, initialData, saving }) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    sourceName: "",
    tags: "",
    isActive: true,
  });
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (!open) return;
    setSubmitError("");
    setForm({
      title: initialData?.title || "",
      description: initialData?.description || "",
      sourceName: initialData?.sourceName || "",
      tags: initialData?.tags || "",
      isActive: initialData?.isActive ?? true,
    });
  }, [open, initialData]);

  const handleSubmit = async () => {
    if (!form.title?.trim()) {
      setSubmitError("عنوان گروه الزامی است.");
      return;
    }
    const result = await onSubmit(form);
    if (result?.error) setSubmitError(result.error);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? "ویرایش گروه مخاطب" : "گروه مخاطب جدید"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              label="عنوان"
              fullWidth
              required
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="توضیحات"
              fullWidth
              multiline
              minRows={2}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="منبع"
              fullWidth
              value={form.sourceName}
              onChange={(e) => setForm({ ...form, sourceName: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="برچسب‌ها"
              fullWidth
              value={form.tags}
              onChange={(e) => setForm({ ...form, tags: e.target.value })}
            />
          </Grid>
          {submitError ? (
            <Grid item xs={12}>
              <TextField error helperText={submitError} fullWidth disabled />
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>انصراف</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadContactGroupFormDialog;
